import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: true
})
export class SafeUrlPipe implements PipeTransform {
  // DomSanitizer is only used to mark external Calendly URLs as trusted resource URLs.
  // This is a deliberate, reviewed exception to Angular's default sanitization because
  // the scheduling URL is generated by our backend / Calendly and must be embedded in an iframe.
  // Ensure any future changes validate sources before bypassing sanitizer.
  private readonly sanitizer = inject(DomSanitizer);

  transform(url: string | undefined): SafeResourceUrl {
    if (!url) {
      // Return a harmless empty string instead of crashing. Tests expect an empty value for undefined input.
      return '' as SafeResourceUrl;
    }
    // We explicitly trust this URL for resource loading (iframe). The caller should ensure the URL
    // comes from a trusted source (server-generated calendly links).
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}